export default __webpack_public_path__ + "static/help_02_01_1-1e7ff32b56721e7cfdc26b66f8bbd3a1.png";